import { render, staticRenderFns } from "./review_drawer.vue?vue&type=template&id=7515dbc6"
import script from "./review_drawer.vue?vue&type=script&lang=js"
export * from "./review_drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports